export enum ResetPasswordConfirmFormFieldNames {
  newPassword = "newPassword",
  newPasswordConfirm = "newPasswordConfirm"
}

export type ResetPasswordConfirmFormFieldValues = {
  [ResetPasswordConfirmFormFieldNames.newPassword]: string
  [ResetPasswordConfirmFormFieldNames.newPasswordConfirm]: string
}

export const resetPasswordConfirmErrorTranslationKeys = {
  InvalidLength: "Validation:LimitCharacterLess",
  ContainsSpaces: "Validation:NoSpaces",
  PasswordsDoNotMatch: "Author.Login:PasswordsDoNotMatch",
  RequestValidityExpired: "Author.Login:RequestValidityExpired"
}
